import { BlockchainNetwork } from '../constants.js'

export const getBlockchainUrlSegment = (blockchain: BlockchainNetwork): string => {
    // all blockchains from explorer, just in case
    switch (blockchain) {
        case BlockchainNetwork.ethereum:
            return 'ethereum'
        case BlockchainNetwork.bitcoin:
            return 'bitcoin'
        case BlockchainNetwork.binance:
            return 'bsc'
        case BlockchainNetwork.cardano:
            return 'cardano'
        case BlockchainNetwork.tron:
            return 'tron'
        case BlockchainNetwork.solana:
            return 'solana'
        case BlockchainNetwork.algorand:
            return 'algorand'
        case BlockchainNetwork.stellar:
            return 'stellar'
        case BlockchainNetwork.ripple:
            return 'ripple'
        case BlockchainNetwork.hedera:
            return 'hedera'
        case BlockchainNetwork.tezos:
            return 'tezos'
        case BlockchainNetwork.filecoin:
            return 'filecoin'
        case BlockchainNetwork.flow:
            return 'flow'
        case BlockchainNetwork.conflux:
            return 'conflux'
        case BlockchainNetwork.elrond:
            return 'elrond'
        case BlockchainNetwork.everscale:
            return 'everscale'
        case BlockchainNetwork.cosmos:
            return 'cosmoshub'
        default:
            return blockchain
    }
}

export const getBitqueryExplorerUrl = (
    blockchain: BlockchainNetwork,
    type: 'address' | 'tx',
    value: string
): string => {
    const networkSegment = getBlockchainUrlSegment(blockchain)
    return `https://explorer.bitquery.io/${networkSegment}/${type}/${value}`
}

